import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { DataGroup } from '../../../../components/data-group/DataGroup';
import { DataGroupPoint } from '../../../../components/data-group/DataGroupPoint';
import ResultDialog from '../../../../components/dialog-types/ResultDialog';
import { TimeZoneAbbreviations } from '../../../../components/utility/timezones';
import { toLongDateTimeNoSeconds } from '../../../../utils/date-utils';
import { RouteStatus } from '../../../models/enums/_index';
import { BackhaulStatus } from '../../../models/enums/backhaul-status';
import { BackhaulShipmentAction } from '../../../models/shipments/shipment-action';
import { IStopAction, StopActionsMenu } from '../StopActionsMenu';

interface IProps {
    backhaul: BackhaulShipmentAction;
    routeStatus: RouteStatus;
    onDeleteBackhaul : any;
    onStartEdit: any;
}

export const ActionContentBackHaul = (props : IProps) => {

    /**
     * Confirm and delete the backhaul. Done through the result dialog, rather than a
     * confirmation trigger, so that the dialog is not lost when the actions menu closes.
     */
    const confirmDelete = async () => {

        const result = await ResultDialog.show({
            title: 'Delete Backhaul?',
            message: 'Are you sure you want to delete this backhaul?',
            affirmativeLabel: 'Yes',
            negativeLabel: 'No'
        });

        if (result) {
            props.onDeleteBackhaul(props.backhaul.id);
        }

    };

    /**
     * Every action the stop allows right now, for the actions menu, which leaves out
     * those the user is not permitted to take.
     */
    const getActions = (): IStopAction[] => {

        const editPermissions = [Permissions.ShippingTrucksEdit, Permissions.ShippingContainersEdit];
        const available: IStopAction[] = [];

        if (props.backhaul.status === BackhaulStatus.Open) {
            available.push({
                id: 'stop-action-edit', text: 'Edit', icon: 'la-pencil',
                requiredPermissions: editPermissions,
                onClick: () => props.onStartEdit(props.backhaul.id)
            });
        }

        if (props.routeStatus !== RouteStatus.Closed && props.routeStatus !== RouteStatus.Cancelled) {
            available.push({
                id: 'stop-action-delete', text: 'Delete', icon: 'la-trash', classes: 'delete-action',
                requiredPermissions: editPermissions,
                onClick: confirmDelete
            });
        }

        return available;
    };

    return <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="stop-panel-heading">
                            <h1 className="stop-panel-title">Backhaul</h1>
                            <StopActionsMenu actions={ getActions() } />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">

                        <DataGroup title="">
                            <DataGroupPoint
                                label="Vendor Name"
                                value={ props.backhaul.vendorName }
                            />

                            <DataGroupPoint
                                label="Stop Time"
                                value={ 
                                    props.backhaul.actionTime
                                    ? `${ toLongDateTimeNoSeconds(props.backhaul.actionTime.local) } ${ TimeZoneAbbreviations[props.backhaul.actionTime.timeZone] }` 
                                        : ''
                                } 
                            />

                            <DataGroupPoint
                                label="Note"
                                value={ props.backhaul.note } 
                            />

                        </DataGroup>

                    </div>
                </div>
            </div>;
};
